export const serviceDetails = [
  {
    id: 'gesichtsbehandlungen',
    icon: 'ri-sparkling-line',
    title: 'Gesichtsbehandlungen',
    shortDescription: 'Professionelle Gesichtsbehandlungen für jeden Hauttyp.',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/7940962fc0dde71a58ffe5f92a4680dc.png',
    description: 'Unsere professionellen Gesichtsbehandlungen sind individuell auf Ihren Hauttyp abgestimmt. Von der gründlichen Reinigung über sanfte Peelings bis hin zu nährenden Masken - wir verwöhnen Ihre Haut mit hochwertigen Produkten und modernsten Techniken.',
    benefits: [
      'Tiefenreinigung der Poren',
      'Verbesserung des Hautbildes',
      'Anti-Aging Wirkung',
      'Entspannung und Wohlbefinden',
      'Individuelle Hautanalyse'
    ],
    process: [
      'Hautanalyse und Beratung',
      'Gründliche Reinigung',
      'Sanftes Peeling',
      'Ausreinigung bei Bedarf',
      'Maske und Pflege',
      'Abschlusspflege mit Serum und Creme'
    ],
    pricingCategory: 'Gesichtsbehandlungen (Nur für Damen)'
  },
  {
    id: 'dauerhafte-haarentfernung',
    icon: 'ri-flashlight-line',
    title: 'Dauerhafte Haarentfernung',
    shortDescription: 'Nie wieder Rasieren mit modernster Lasertechnologie.',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20laser%20hair%20removal%20treatment%20in%20professional%20beauty%20clinic%20clean%20white%20aesthetic%20advanced%20technology%20equipment%20soft%20lighting%20minimalist%20medical%20spa%20atmosphere%20rose%20gold%20details&width=1200&height=600&seq=laser1&orientation=landscape',
    description: 'Mit der geballten Kraft von drei verschiedenen Wellenlängen bieten wir Ihnen eine effektive und dauerhafte Lösung zur Haarentfernung. Unsere moderne Technologie ist für alle Hauttypen geeignet und sorgt für langanhaltende Ergebnisse.',
    benefits: [
      'Für alle Hauttypen geeignet',
      'Langanhaltende Ergebnisse',
      'Schmerzarme Behandlung',
      'Keine eingewachsenen Haare mehr',
      'Zeit- und Kostenersparnis langfristig'
    ],
    process: [
      'Kostenlose Beratung und Hautanalyse',
      'Vorbereitung der Behandlungszone',
      'Anpassung der Lasereinstellungen',
      'Präzise Behandlung',
      'Kühlung und Nachpflege',
      'Terminplanung für Folgebehandlungen'
    ],
    pricingCategory: 'Dauerhafte Haarentfernung (Nur für Damen)'
  },
  {
    id: 'waxing',
    icon: 'ri-scissors-line',
    title: 'Waxing',
    shortDescription: 'Hautschonende und effiziente Haarentfernung.',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/a60e1cff3bea6ee6e655e2472b3560f2.jpeg',
    description: 'Professionelles Waxing für seidig glatte Haut. Wir verwenden hochwertiges Wachs, das besonders hautschonend ist und für ein langanhaltendes Ergebnis sorgt. Ideal für Gesicht, Arme, Beine und Intimbereich.',
    benefits: [
      'Bis zu 4 Wochen glatte Haut',
      'Haare wachsen feiner nach',
      'Hautschonendes Wachs',
      'Schnelle Behandlung',
      'Gründliche Haarentfernung'
    ],
    process: [
      'Reinigung der Haut',
      'Auftragen des warmen Wachses',
      'Schnelles Abziehen gegen Wuchsrichtung',
      'Entfernung von Wachsresten',
      'Beruhigende Nachpflege'
    ],
    pricingCategory: 'Waxing (Nur für Damen)'
  },
  {
    id: 'wimpern-augenbrauen',
    icon: 'ri-eye-line',
    title: 'Wimpern & Augenbrauen',
    shortDescription: 'Betonen Sie das Schönste - Ihre Augen!',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/87830678e557e8b97921d5a2df2938a0.jpeg',
    description: 'Wimpernlifting, Browlifting, Färben und Zupfen - wir bieten Ihnen das komplette Programm für einen ausdrucksstarken Blick. Mit professionellen Produkten und präziser Technik betonen wir Ihre natürliche Schönheit.',
    benefits: [
      'Ausdrucksstarker Blick',
      'Natürliches Ergebnis',
      'Langanhaltende Wirkung',
      'Kein tägliches Schminken nötig',
      'Individuelle Beratung'
    ],
    process: [
      'Beratung und Farbauswahl',
      'Reinigung der Augenpartie',
      'Präzise Behandlung',
      'Einwirkzeit bei Färbung/Lifting',
      'Finishing und Styling'
    ],
    pricingCategory: 'Wimpern & Augenbrauen (Nur für Damen)'
  },
  {
    id: 'aqua-facial',
    icon: 'ri-drop-line',
    title: 'Aqua Facial',
    shortDescription: 'Wellness für Ihre Haut!',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/3651fce79466d70c06dfacbc7be6c26e.jpeg',
    description: 'Das Aqua Facial ist eine mehrstufige Behandlung, die Reinigung, Peeling, Extraktion und Hydration kombiniert. Mit speziellen Seren wird Ihre Haut tiefenwirksam gepflegt und erhält einen strahlenden Glow.',
    benefits: [
      'Sofort sichtbare Ergebnisse',
      'Tiefenreinigung der Poren',
      'Intensive Hydration',
      'Verfeinertes Hautbild',
      'Für alle Hauttypen geeignet'
    ],
    process: [
      'Reinigung und Vorbereitung',
      'Sanftes Peeling',
      'Tiefenreinigung mit Vakuum',
      'Infusion von Wirkstoffen',
      'LED-Lichttherapie',
      'Abschlusspflege'
    ],
    pricingCategory: 'Aqua Facial'
  },
  {
    id: 'micro-needling',
    icon: 'ri-contrast-drop-line',
    title: 'Micro-Needling (BioRePeel CL3)',
    shortDescription: 'Moderne Hautverbesserung für ein jugendliches Hautbild.',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/777bdc0e0767d4c656f012d54303cecd.jpeg',
    description: 'Micro-Needling stimuliert die natürliche Kollagenproduktion Ihrer Haut. Feine Nadeln erzeugen kontrollierte Mikroverletzungen, die den Heilungsprozess aktivieren und für ein strafferes, ebenmäßigeres Hautbild sorgen.',
    benefits: [
      'Stimuliert Kollagenproduktion',
      'Reduziert Falten und Narben',
      'Verfeinert die Poren',
      'Verbessert die Hautstruktur',
      'Natürliche Hautverjüngung'
    ],
    process: [
      'Hautanalyse und Beratung',
      'Reinigung und Desinfektion',
      'Auftragen von Betäubungscreme',
      'Micro-Needling Behandlung',
      'Einarbeitung von Wirkstoffen',
      'Beruhigende Nachpflege'
    ],
    pricingCategory: 'Micro-Needling & BioRePeel'
  },
  {
    id: 'bio-repeel',
    icon: 'ri-heart-pulse-line',
    title: 'Maniküre & Pediküre',
    shortDescription: 'Professionelle Nagelpflege für gepflegte Hände und Füße.',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/87bf7cd3dc60f42e5ba40ebcc5fccf40.jpeg',
    description: 'Professionelle Nagelpflege und Nageldesign für perfekt gepflegte Hände und Füße. Von der klassischen Maniküre über moderne Gel-Nägel bis hin zu kreativem Nageldesign - wir verwöhnen Ihre Hände und Füße mit hochwertigen Produkten und präziser Handwerkskunst.',
    benefits: [
      'Gepflegte und schöne Nägel',
      'Langanhaltende Ergebnisse',
      'Hochwertige Produkte',
      'Individuelle Designs',
      'Professionelle Beratung'
    ],
    process: [
      'Beratung und Designauswahl',
      'Vorbereitung der Nägel',
      'Formgebung und Pflege',
      'Auftragen der Lackierung',
      'Versiegelung',
      'Abschlusspflege'
    ],
    pricingCategory: 'Maniküre & Pediküre (Nur für Damen)'
  },
  {
    id: 'microdermabrasion',
    icon: 'ri-contrast-2-line',
    title: 'Microdermabrasion',
    shortDescription: 'Sanfte mechanische Hautabtragung für strahlenden Teint.',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/337352b470abf4d5e2094d033d736c87.png',
    description: 'Die Microdermabrasion ist eine sanfte, mechanische Methode zur Hautabtragung. Abgestorbene Hautzellen werden entfernt und die Durchblutung angeregt, was zu einem verfeinerten Hautbild und strahlendem Teint führt.',
    benefits: [
      'Verfeinert das Hautbild',
      'Regt Durchblutung an',
      'Reduziert feine Linien',
      'Verbessert Produktaufnahme',
      'Sofort sichtbare Ergebnisse'
    ],
    process: [
      'Reinigung der Haut',
      'Microdermabrasion Behandlung',
      'Absaugung abgestorbener Zellen',
      'Beruhigende Maske',
      'Feuchtigkeitspflege'
    ],
    pricingCategory: 'Microdermabrasion'
  },
  {
    id: 'rueckenbehandlung',
    icon: 'ri-user-heart-line',
    title: 'Rückenbehandlung',
    shortDescription: 'Spezielle Behandlungen für unreine Haut am Rücken.',
    heroImage: 'https://static.readdy.ai/image/f83fdda0eecfb5cfc6917dd44bd1d231/41c0359a528806bcd5a75b0c2de17d6f.png',
    description: 'Unsere Rückenbehandlung ist speziell für unreine Haut am Rücken konzipiert. Tiefenreinigung, Peeling und pflegende Masken sorgen für ein reines, gepflegtes Hautbild - auch an schwer erreichbaren Stellen.',
    benefits: [
      'Tiefenreinigung des Rückens',
      'Reduziert Unreinheiten',
      'Entspannende Massage',
      'Verfeinertes Hautbild',
      'Wohltuende Pflege'
    ],
    process: [
      'Reinigung des Rückens',
      'Peeling',
      'Ausreinigung bei Bedarf',
      'Beruhigende Maske',
      'Massage',
      'Abschlusspflege'
    ],
    pricingCategory: 'Spezialbehandlungen'
  }
];
